import { Component } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BlogPageService } from '../../blog-page/services/blog-page.service';
import { environment } from '../../../../environments/environment.development';

@Component({
  selector: 'app-blog-page',
  templateUrl: './blog-page.component.html',
  styleUrls: ['./blog-page.component.scss']
})
export class BlogPageComponent {
  form: FormGroup;
  serverErrors: any;
  preview: string;
  preview2: string;
  blogs: any;
  Add = false;
  Edit = false;
  path: string;

  constructor(
    private router: Router,
    private _fb: FormBuilder,
    private service: BlogPageService,
    private toastr: ToastrService,
    private route: ActivatedRoute
  ) {
    this.form = this._fb.group({
      _id:[''],
      mainTitle: [''],
      mainParagraph: [''],
      image: [''],
      coinName: [''],
      coinParagraph: [''],
      paragraphTitle1: [''],
      paragraphDescription1: [''],
        paragraphTitle2: [''],
      paragraphDescription2: [''],
        paragraphTitle3: [''],
      paragraphDescription3: [''],
        paragraphTitle4: [''],
      paragraphDescription4: [''],
        paragraphTitle5: [''],
      paragraphDescription5: [''],
      graphImage: [''],
      supportIndicator: [''],
      resistanceIndicator: [''],
      dayEMA: [''],
      RSI: [''],
      dailyPridiction: [''],
      weeklyPridiction: [''],
      yearlyPridiction: ['']
    });
  }

  ngOnInit() {
    this.getData();
    this.path=(environment.userApiUrl)
  }

getData(): void {
    this.service.getData().subscribe({
      next: (v: any) => {
        this.blogs = v.data;
      },
      error: () => {
      }
    });
  }

submitForm() {
  const formValue = this.form.value;
  const formData = new FormData();
  formData.append('mainTitle', formValue.mainTitle);
  formData.append('mainParagraph', formValue.mainParagraph);
  formData.append('image', formValue.image);
  formData.append('coinName', formValue.coinName);
  formData.append('coinParagraph', formValue.coinParagraph);
  formData.append('paragraphTitle1', formValue.paragraphTitle1);
  formData.append('paragraphDescription1', formValue.paragraphDescription1);
  formData.append('paragraphTitle2', formValue.paragraphTitle2);
  formData.append('paragraphDescription2', formValue.paragraphDescription2);
  formData.append('paragraphTitle3', formValue.paragraphTitle3);
  formData.append('paragraphDescription3', formValue.paragraphDescription3);
  formData.append('paragraphTitle4', formValue.paragraphTitle4);
  formData.append('paragraphDescription4', formValue.paragraphDescription4);
  formData.append('paragraphTitle5', formValue.paragraphTitle5);
  formData.append('paragraphDescription5', formValue.paragraphDescription5);
  formData.append('graphImage', formValue.graphImage); 
  formData.append('supportIndicator', formValue.supportIndicator);
  formData.append('resistanceIndicator', formValue.resistanceIndicator);
  formData.append('dayEMA', formValue.dayEMA);
  formData.append('RSI', formValue.RSI);
  formData.append('dailyPridiction', formValue.dailyPridiction);
  formData.append('weeklyPridiction', formValue.weeklyPridiction);
  formData.append('yearlyPridiction', formValue.yearlyPridiction);
  this.service.Add(formData).subscribe({
    next: (v: any) => {
      this.router.navigateByUrl("/blog-page");
      this.serverErrors = {};
      this.toastr.success(v.message);
      this.Add = false;
      this.Edit = false;
    },
    error: err => {
      if ([400, 404].includes(err.status)) {
        const validationErrors = err.error.errors;
        this.serverErrors = validationErrors || {};
      } else if (err.status === 500) {
        this.toastr.error(err.error.message);
      }
    },
    complete: () => {}
  });
}

updateForm() {
  const formValue = this.form.value;
  const formData = new FormData();
    formData.append('mainTitle', formValue.mainTitle);
  formData.append('_id', formValue._id);
  formData.append('mainTitle', formValue.mainTitle);
  formData.append('mainParagraph', formValue.mainParagraph);
  formData.append('image', formValue.image);
  formData.append('coinName', formValue.coinName);
  formData.append('coinParagraph', formValue.coinParagraph);
  formData.append('paragraphTitle1', formValue.paragraphTitle1);
  formData.append('paragraphDescription1', formValue.paragraphDescription1);
  formData.append('paragraphTitle2', formValue.paragraphTitle2);
  formData.append('paragraphDescription2', formValue.paragraphDescription2);
  formData.append('paragraphTitle3', formValue.paragraphTitle3);
  formData.append('paragraphDescription3', formValue.paragraphDescription3);
  formData.append('paragraphTitle4', formValue.paragraphTitle4);
  formData.append('paragraphDescription4', formValue.paragraphDescription4);
  formData.append('paragraphTitle5', formValue.paragraphTitle5);
  formData.append('paragraphDescription5', formValue.paragraphDescription5);
  formData.append('graphImage', formValue.graphImage); 
  formData.append('supportIndicator', formValue.supportIndicator);
  formData.append('resistanceIndicator', formValue.resistanceIndicator);
  formData.append('dayEMA', formValue.dayEMA);
  formData.append('RSI', formValue.RSI);
  formData.append('dailyPridiction', formValue.dailyPridiction);
  formData.append('weeklyPridiction', formValue.weeklyPridiction);
  formData.append('yearlyPridiction', formValue.yearlyPridiction);
  this.service.Update(formData).subscribe({
    next: (v: any) => {
      this.router.navigateByUrl("/blog-page");
      this.serverErrors = {};
      this.toastr.success(v.message);
          this.Add = false;
          this.Edit = false;
    },
    error: err => {
      if ([400, 404].includes(err.status)) {
        const validationErrors = err.error.errors;
        this.serverErrors = validationErrors || {};
      } else if (err.status === 500) {
        this.toastr.error(err.error.message);
      }
    },
    complete: () => {}
  });
}

deleteBlog(id:any){
  this.service.deleteBlog(id).subscribe({
    next: (v:any) => {
      this.toastr.success(v.message);
      this.getData();
    },
    error: (err:any) => {
      this.toastr.error(err.error.message);
    }
  });
}

editBlog(blog: any) {
  this.Edit = true;
  this.Add = false;
  this.form.patchValue({
    _id: blog._id || '',
    mainTitle: blog.mainTitle || '',
    mainParagraph: blog.mainParagraph || '',
    image: blog.image || '',
    coinName: blog.coinName || '',
    coinParagraph: blog.coinParagraph || '',
    paragraphTitle1: blog.paragraphTitle1 || '',
    paragraphDescription1: blog.paragraphDescription1 || '',
    paragraphTitle2: blog.paragraphTitle2 || '',
    paragraphDescription2: blog.paragraphDescription2 || '',
    paragraphTitle3: blog.paragraphTitle3 || '',
    paragraphDescription3: blog.paragraphDescription3 || '',
    paragraphTitle4: blog.paragraphTitle4 || '',
    paragraphDescription4: blog.paragraphDescription4 || '',
    paragraphTitle5: blog.paragraphTitle5 || '',
    paragraphDescription5: blog.paragraphDescription5 || '',
    graphImage: blog.graphImage || '',
    supportIndicator: blog.supportIndicator || '',
    resistanceIndicator: blog.resistanceIndicator || '',
    dayEMA: blog.dayEMA || '',
    RSI: blog.RSI || '',
    dailyPridiction: blog.dailyPridiction || '',
    weeklyPridiction: blog.weeklyPridiction || '',
    yearlyPridiction: blog.yearlyPridiction || ''
  });
  this.preview = blog.image ? (environment.userApiUrl +'/slider/  '+ blog.image) : '';
  this.preview2 = blog.graphImage ? (environment.userApiUrl +'/slider/' + blog.graphImage) : '';
}

  onInputChange() {
    this.serverErrors = {}
  }

  upload(event: Event) {
    const target = event.target as HTMLInputElement;
    const files = target.files as FileList;
    this.form.patchValue({
      image: files[0]
    })
    const reader = new FileReader();
    reader.onload = () => {
      this.preview = reader.result as string;
    }
    reader.readAsDataURL(files[0])
  }

  upload2(event: Event) {
    const target = event.target as HTMLInputElement;
    const files = target.files as FileList;
    this.form.patchValue({
      graphImage: files[0]
    })
    const reader = new FileReader();
    reader.onload = () => {
      this.preview2 = reader.result as string;
    }
    reader.readAsDataURL(files[0])
  }

  addBlog(){
    this.Edit = false;
    this.Add = true;
  }

  listBlog(){
    this.Add = false;
    this.Edit = false;
  }

}
